import React, { useState, useEffect } from 'react';
import { Button } from 'semantic-ui-react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

const textTransforms = ['none', 'uppercase'];

const Uppercase = props => {
  const enabledEditorId = useSelector(state => state.design.enabledEditorId);
  const textTransform = useSelector(state => state.design.textTransform);
  const [transformIndex, setTransformIndex] = useState(0);

  useEffect(() => {
    setTransformIndex(textTransform ? textTransforms.indexOf(textTransform) : 0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [textTransform]);

  const onToggle = e => {
    e.preventDefault();
    const nextIndex = (transformIndex + 1) % 2;
    setTransformIndex(nextIndex);

    const newStyle = {
      type: 'uppercase',
      all: props.entityId !== enabledEditorId,
      value: textTransforms[nextIndex],
    };
    props.onChange(newStyle);
  };

  return <Button icon="text cursor" onMouseDown={onToggle} />;
};

Uppercase.propTypes = {
  entityId: PropTypes.number,
  editorState: PropTypes.any,
  onChange: PropTypes.func,
  ids: PropTypes.any,
  editorsState: PropTypes.any,
};

export default Uppercase;
